const headerNavLinks = [
  { href: '/', title: '首页' },
  { href: '/blog', title: '博客' },
  { href: '/tags', title: '标签' },
  // { href: '/projects', title: 'Projects' },
  // { href: '/about', title: 'About' },
]

export default headerNavLinks
